import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { CartContext } from '../../contexts/CartContext';
import DealershipContext, { useDealership } from '../../contexts/DealershipContext';
import ProductImage from '../../components/ProductImage';
import Button from '../../components/Button';
import './ProductTemplatePage.css';

const ProductTemplatePage = () => {
  // Params from the URL - check both possible parameter names
  const { id, productId } = useParams();
  const actualProductId = id || productId;
  
  // Contexts
  const { addToCart } = useContext(CartContext);
  const { 
    dealership,
    productDetails, 
    productLoading, 
    productError,
    getProductDetails 
  } = useDealership();
  
  // Fetch product details on component mount
  useEffect(() => {
    if (actualProductId) {
      getProductDetails(actualProductId);
    }
  }, [actualProductId, getProductDetails]);
  
  const handleAddToCart = () => {
    if (!productDetails) return;
    
    const productToAdd = {
      id: productDetails.id,
      name: productDetails.name || "Product",
      price: productDetails.price || 0,
      image: `./${productDetails.image}`,
    };
    addToCart(productToAdd);
  };
  
  if (productLoading) {
    return <p>Loading product details...</p>;
  }
  
  if (productError) {
    return <p>Error: {productError}</p>;
  }
  
  if (!productDetails) {
    return <p>No product details found for ID: {actualProductId}</p>;
  }
  
  return (
    <div className="project-template-page">
      {/* Page Title */}
      <h1 className="page-title">{productDetails.name || "Product Template"}</h1>
      
      {/* Product and Data Form */}
      <div className="row space-around align-middle">
        {/* Product Image */}
        <div className="col col-6 align-center">
          <ProductImage 
            imgSrc={productDetails.image} 
            imgAltText={productDetails.name} 
          />
        </div>
        
        {/* Form Data */}
        <div className="col col-6 align-middle">
          <h2>{dealership?.name}</h2>
          <p>{dealership?.address?.street}</p>
          <p>
            {dealership?.address?.city}, {dealership?.address?.state} {dealership?.address?.zip}
          </p>
          <br />
          
          {/* Employees Data */}
          <h2>Select employee from list &gt;</h2>
          <h2 className="row">
            <div className="col col-xs-8">Input Employee info:</div>
            <div className="col col-xs-4 align-right">
              <Button onClick={() => {}}>ADD</Button>
            </div>
          </h2>
          <p>Employee List</p>
          <select>
            {dealership?.employees?.map((employee) => (
              <option key={employee.email || employee.id}>{employee.name}</option>
            )) || <option>No employees available</option>}
          </select>
        </div>
      </div>
      

      
      {/* Review Disclosure */}
      <div className="row align-center">
        <div className="col col-10 text-left">
          <h2>Please review your {productDetails.type || "product"}(s).</h2>
          <p>
            Double checking for things like spelling, correct phone numbers,
            email address, etc.
          </p>
          <p>
            Additional revisions once a proof is signed off on may incur additional charges.
          </p>
        </div>
      </div>
      
      {/* Buttons */}
      <div className="row align-center">
        <div className="col col-10">
          <div className="row">
            <div className="col col-2 align-left">
              <Button onClick={handleAddToCart}>ADD TO CART</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTemplatePage;
